import { axiosGet, axiosPost } from "../../react_axios/Axios";
import { ENTRY_GATE_VERIFY_QR, ENTRY_GATE_QR_LIST, ENTRY_GATE_UPDATE_ACCESS_PASS_LOG, entryGateVerifyQRUrl, headers, entryGateQRListUrl, entryGateUpdateAccessPassLogUrl } from "../../utils/constants";

export const entryGateVerifyQR_action = (IsEntry, UUID, IsByPass, Remark, AdditionalRemark, IsEntryExit) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem("loginDataSS")).UserID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            IsEntry: IsEntry,
            UUID: UUID,
            IsByPass: IsByPass !== "" ? IsByPass : null,
            Remark: Remark !== "" ? Remark : null,
            AdditionalRemark: AdditionalRemark !== "" ? AdditionalRemark : null,
            IsEntryExit: IsEntryExit,
        };

        const res = await axiosPost(entryGateVerifyQRUrl, params, headers);

        // 🔴 Throw error if API failed
        if (!res || res?.error === 1 || res?.status === 500) {
            throw new Error(res?.message || "Server Error");
        }

        dispatch({
            type: ENTRY_GATE_VERIFY_QR,
            payload: res,
        });

        return res;

    } catch (error) {
        throw error; // important so component catch runs
    }
};

export const entryGateQRList_action = (CompanyName, FilterDate,IsEntryExit) => async (dispatch) => {

    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            CompanyName: CompanyName,
            FilterDate: FilterDate,
            IsEntryExit: IsEntryExit,
        }

        const res = await axiosGet(entryGateQRListUrl, params, headers)

        dispatch({
            type: ENTRY_GATE_QR_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const entryGateUpdateAccessPassLog_action = (AccessPassLogID, IsByPass, Remark, AdditionalRemark,ReasonID) => async (dispatch) => {

    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            AccessPassLogID: AccessPassLogID,
            IsByPass: IsByPass,
            Remark: Remark,
            AdditionalRemark: AdditionalRemark,
            ReasonID: ReasonID,
        }

        const res = await axiosPost(entryGateUpdateAccessPassLogUrl, params, headers)

        dispatch({
            type: ENTRY_GATE_UPDATE_ACCESS_PASS_LOG,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}